import { ModelFactory } from '@shared/factories/model.factory';
import { PaymentProviderType } from '@generated/graphql';
import { PaymentProvider } from '@modules/payment/models/payment-provider.model';

export class PaymentProviderFactory extends ModelFactory<PaymentProviderType, PaymentProvider> {
  create (state: PaymentProviderType): PaymentProvider {
    return new PaymentProvider(state);
  }
}

export const paymentProviderFactory = new PaymentProviderFactory();
